import React from "react";
import { Button } from "reactstrap";
import styled from "styled-components";
import { withApollo } from "react-apollo";
import StatusIcon from "../../AutomationStatus/StatusIcon";

export const CardContent = styled.div`
  max-width: 300px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
`;


const AutomationStatus = ({
  automationStatus: {
    currentAutomationStatus: {
      description,
      status,
      url
    }
  }
}) => (
  <div className="content">
    <CardContent>
      <StatusIcon size="md" type={status} />
      <h3 style={{ marginTop: "20px", textAlign: "center" }}>
        {description}
      </h3>
      {
        url && (
          <Button
            className="btn-info"
            href={url}
            target="_blank"
            style={{ marginTop: "10px" }}
          >
            CLIQUE PARA OBTER AJUDA
          </Button>
        )
      }
    </CardContent>
  </div>
);

export default withApollo(AutomationStatus);
